import { all, fork } from 'redux-saga/effects'

import customerAuth from './customerAuth.saga'

export default function* rootSaga() {
	yield all([fork(customerAuth)])
}
